import React,{useState,useEffect }from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MainContainer from '../../components/MainContainer';
import { Grid, MenuItem, Select, FormControl } from "@material-ui/core";
import Paper from '@material-ui/core/Paper';
import { AntTab, AntTabs } from '../../components/ant-tab';
import AppBar from "@material-ui/core/AppBar";
import Spacer from "../../components/Spacer";
import { useContext } from "react";
import { userDetailContext } from '../../App';
import { hasPrivilege } from '../../utils/privilege';
import { RecapLeaveHeader } from '../../data/modules/recap_header';
import LoadingSimpleBackdrop from '../tools/LoadingSimpleBackdrop';
import { Button } from "@material-ui/core";
import RecapLeaveService from '../../services/RecapLeaveService';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography,Dialog,
  DialogTitle,
  DialogContent,
  DialogActions } from '@mui/material';
import { DownloadOutlined } from "@mui/icons-material";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    elevation: 0
  },
  paperLeaveInDay:{
    
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    elevation: 0
  },
  tab1:{
    width: "40%"
  }
}));

export default function RecapLeave() {

  const classes = useStyles()
  const [value, setValue] = React.useState(0);
  const contextData = useContext(userDetailContext);
  const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = useState(false);
   const [open, setOpen] = useState(false);
   const currentYear = new Date().getFullYear();
   const[loading,setLoading]=useState(false);
   const [loadingexport,setLoadingexport]=useState(false);
   const [rows,setRows]=useState([]);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [historyData,setHistoryData]=useState([]);
   const getPreviousMonth = () => {
    const now = new Date();
    now.setMonth(now.getMonth() - 1);
    return now.getMonth() + 1; 
  };

    const handleOpen = () => {
        setOpen(true);
          RecapLeaveService.history().then((result) => {
            if (result && result.data) {  
               setHistoryData(result.data);
            }
         }).catch((error) => {
            setHistoryData([]);
        });
    };

    const handleClose = () => {
        setOpen(false);
    };

  const [month, setMonth] = useState(getPreviousMonth());

  const getYearRange = (defaultYear = new Date().getFullYear()) => {
  const startYear = 2024;
  const years = [];
    
    for (let year = startYear; year <= defaultYear; year++) {
        years.push(year);
    }
    
    return years;
    };

    const years = getYearRange();
    function handleChangeyear(ev) {
        const yearSelected = ev.target.value;
        setSelectedYear(yearSelected);
    }

      const downloadFile = (filename) => {
            const url = `https://pgi.fid.mg/pgibackend/uploads/Rapportmensuelconge/${filename}`;
          // const url = `https://16fidmg.org/pgibackend_dev/uploads/Rapportmensuelconge/${filename}`;

            const link = document.createElement('a');
            link.href = url;
            link.download = filename; 

            fetch(url, { method: 'HEAD' })
                .then((response) => {
                    if (response.ok) {
                        link.click();
                    } else {
                        alert('Le fichier est introuvable ou il y a un problème avec l\'URL.');
                    }
                })
                .catch((error) => {
                    alert('Erreur lors du téléchargement du fichier.');
                });
        };

    
    function handleChange(ev) {
        const monthSelected = ev.target.value;
        setMonth(monthSelected);
    }

     useEffect(() => {
         setLoading(true);
         setOpenLoadingSimpleBackdrop(true);
        RecapLeaveService.liste(month,selectedYear).then((result) => {
            if (result && result.data) {  
               setRows(result.data);
               setLoading(false);
               setOpenLoadingSimpleBackdrop(false);
            }
         }).catch((error) => {
            setRows([]);
            setLoading(false);
            setOpenLoadingSimpleBackdrop(false);
        });
    }, []);

     function handleClickFilter() {
         setLoading(true);
         setOpenLoadingSimpleBackdrop(true);
          RecapLeaveService.liste(month,selectedYear).then((result) => {
            if (result && result.data) {  
               setRows(result.data);
               setLoading(false);
               setOpenLoadingSimpleBackdrop(false);
            }
         }).catch((error) => {
            setRows([]);
            setLoading(false);
            setOpenLoadingSimpleBackdrop(false);
        });
     }

    function handleExport() {
        setLoadingexport(true);

        RecapLeaveService.excel(month, selectedYear)
            .then((result) => {
            setLoadingexport(false);

            if (result?.data?.url) {
                // const downloadLink = document.createElement('a');
                // downloadLink.href = result.data.url;
                // downloadLink.download = result.data.filename || 'export.xlsx';
                // downloadLink.target = '_blank';
                // document.body.appendChild(downloadLink);
                // downloadLink.click();
                // document.body.removeChild(downloadLink);
                downloadFile(result.data.filename);
            } else {
                alert('Le fichier n’a pas pu être généré.');
            }
            })
            .catch((error) => {
                setLoadingexport(false);
                alert('Une erreur est survenue pendant l’export.');
            });
        }

    


  return (
    <MainContainer {...RecapLeaveHeader}>
         <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
         <Grid container justifyContent="center" spacing={2}>
              {/* <Grid item xs={12}></Grid> */}
               <Grid item xs={10}></Grid>
              <Grid item xs={2}>
                         <Button variant="text" onClick={handleOpen}>Voir historique</Button>
                 </Grid>
              <Grid item xs={2}>
                    <FormControl fullWidth variant="outlined" size="small">
                        <Select
                          labelId="demo-simple-select-outlined-label"
                           id="demo-simple-select-outlined"
                           value={selectedYear}
                           name="year"
                           onChange={handleChangeyear}
                         >
                         {years.map((year, index) => (
                            <MenuItem key={index} value={year}>
                                {year}
                         </MenuItem>
                            ))}
                            </Select>
                        </FormControl>
                </Grid>
                  <Grid item xs={2}>
                        <FormControl fullWidth variant="outlined" size="small">
                            <Select labelId="demo-simple-select-outlined-label" id="demo-simple-select-outlined" value={month} name="month" onChange={handleChange} >
                                <MenuItem value="1">Janvier</MenuItem>
                                <MenuItem value="2">Fevrier</MenuItem>
                                <MenuItem value="3">Mars</MenuItem>
                                <MenuItem value="4">Avril</MenuItem>
                                <MenuItem value="5">Mai</MenuItem>
                                <MenuItem value="6">Juin</MenuItem>
                                <MenuItem value="7">Juillet</MenuItem>
                                <MenuItem value="8">Août</MenuItem>
                                <MenuItem value="9">Septembre</MenuItem>
                                <MenuItem value="10">Octobre</MenuItem>
                                <MenuItem value="11">Novembre</MenuItem>
                                <MenuItem value="12">Décembre</MenuItem>
                            </Select>
                        </FormControl>
                 </Grid>
                 <Grid item xs={2}>
                       <Button
                         variant="contained"
                        onClick={handleClickFilter}
                        style={{ fontWeight: 600 }}
                        disabled={loading} 
                         color="primary"
                        >
                        {loading ? 'Chargement...' : 'FILTRER'}
                       </Button>
                 </Grid>
                    <Grid item xs={2}>
                       <Button
                         variant="contained"
                         onClick={handleExport}
                        style={{ fontWeight: 600 }}
                        disabled={loadingexport} 
                        >
                        {loadingexport ? 'Chargement...' : 'EXPORTER'}
                       </Button>
                 </Grid>
                 

         </Grid>
         <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
             <TableContainer component={Paper} sx={{ marginTop: 3 }} style={{width:"80%"}} >
                    {rows.length === 0 ? (
                        <Typography sx={{ padding: 3, textAlign: 'center' }}>
                        Aucune réponse disponible
                        </Typography>
                    ) : (
                        <Table >
                        <TableHead sx={{ backgroundColor: '#f5f5f5'}}>
                            <TableRow>
                            <TableCell sx={{ fontWeight: 'bold' }}>Direction</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}  style={{textAlign:"center"}}>Nombre personnel ayant pris de congé</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}  style={{textAlign:"center"}}>Congé consommé du mois</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}  style={{textAlign:"center"}}>Date de référence</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}  style={{textAlign:"center"}}>Utilisateur</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}  style={{textAlign:"center"}}>Fichier référent</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row, index) => (
                            <TableRow key={index}>
                                <TableCell >{row.direction_code}</TableCell>
                                <TableCell  style={{textAlign:"center"}}>{row.nbruser}</TableCell>
                                <TableCell  style={{textAlign:"center"}}>{row.conge * -1}</TableCell>
                                <TableCell  style={{textAlign:"center"}}>{row.date}</TableCell>
                                <TableCell  style={{textAlign:"center"}}>{row.nom}</TableCell>
                                <TableCell  style={{textAlign:"center"}}>
                                    {row.filename==="Aucun" &&
                                       <>
                                       </>
                                    }
                                    {row.filename!=="Aucun"&&
                                            <Button
                                                    icon={<DownloadOutlined />}
                                                    onClick={() => downloadFile(row.filename)}
                                               >
                                                    <DownloadOutlined style={{ color: "#1a5fa1" }} />
                                                    Télécharger Excel
                                            </Button>
                                    }
                                    </TableCell>
                            </TableRow>
                            ))}
                             <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                <TableCell sx={{ fontWeight: 'bold' }}>Total général</TableCell>
                                <TableCell sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                                    {
                                        rows?.reduce((total, row) => {
                                        const value = Number(row.nbruser) || 0;
                                        return total + value;
                                        }, 0)
                                    }
                                    </TableCell>

                               <TableCell sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                                {
                                    (-1 * rows?.reduce((total, row) => {
                                    const value = Number(row.conge) || 0;
                                    return total + value;
                                    }, 0)).toFixed(2)
                                }
                                </TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}></TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}></TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}></TableCell>
                            </TableRow>
                        </TableBody>
                        </Table>
                    )}
                    </TableContainer>
         </div>
         <div>

        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="md"
            fullWidth
            classes={{ paper: classes.dialog }}
        >
            <DialogTitle>Historique</DialogTitle>
            
            <DialogContent>
            <Table className={classes.table}>
                <TableHead>
                <TableRow>
                    <TableCell>Année</TableCell>
                    <TableCell>Mois</TableCell>
                    <TableCell>Nom et Prénom </TableCell>
                    <TableCell>Date</TableCell>
                    <TableCell>Heure</TableCell>
                    <TableCell>Version Excel</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {historyData.map((row, index) => (
                    <TableRow key={index}>
                    <TableCell>{row.year}</TableCell>
                    <TableCell>{row.month}</TableCell>
                    <TableCell>{row.nom_complet}</TableCell>
                    <TableCell>{row.date_export}</TableCell>
                    <TableCell>{row.heure_export}</TableCell>
                    <TableCell>
                        <Button
                          icon={<DownloadOutlined />}
                           onClick={() => downloadFile(row.filename)}
                        >
                                <DownloadOutlined style={{ color: "#1a5fa1" }} />
                            Télécharger Excel
                         </Button>
                    </TableCell>
                    </TableRow>
                ))}
                </TableBody>
            </Table>
            </DialogContent>

            <DialogActions>
            <Button onClick={handleClose} color="primary">
                Fermer
            </Button>
            </DialogActions>
        </Dialog>
        </div>
    </MainContainer>
  );
}
